import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsNullHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Null;
    }
}

//# sourceMappingURL=IsNullHelper.js.map
